import React from "react";
// css
import "../media/css/contact.css";
// body
const Contact = () => {
  return (
    <section id="contact" className="section-contact">
      <div className="container">
        <div className="header">
          <h2>CONTACT</h2>
          <span>Get in Touch</span>
        </div>
        <div className="wrap">
          <div className="card info">
            <div className="rows">
              <strong>DON'T BE SHY !</strong>
              <span className="text">
                Feel free to get in touch with me. I am always open to
                discussing new projects, creative ideas or opportunities to be
                part of your visions.
              </span>
              <small>DETAILS</small>

              <div className="row">
                <i className="bi bi-geo-alt-fill"></i>
                <div className="content">
                  <p>ADDRESS POINT</p>
                  <span>
                    123 Stree New York City, United States Of America 750065.
                  </span>
                </div>
              </div>
              <div className="row">
                <i className="bi bi-envelope-at-fill"></i>
                <div className="content">
                  <p>MAIL ME</p>
                  <span>mymail@gmail.com</span>
                </div>
              </div>
              <div className="row">
                <i className="bi bi-telephone-fill"></i>
                <div className="content">
                  <p>CALL ME</p>
                  <span>+216 21 184 010</span>
                </div>
              </div>
            </div>

            <div className="social">
              <a href="#">
                <i className="bi bi-behance"></i>
              </a>
              <a href="#">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="#">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#">
                <i className="bi bi-pinterest"></i>
              </a>
              <a href="#">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#">
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </div>
          <form action="#" className="card form">
            <div className="gr">
              {/* Добавил label для улучшенной доступности */}
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Your name"
                required
              />
              <input
                id="mail"
                name="mail"
                type="email"
                placeholder="Your mail"
                required
              />
            </div>
            <input
              id="subject"
              name="subject"
              type="text"
              placeholder="Your subject"
              required
            />
            <textarea
              id="message"
              name="message"
              cols="30"
              rows="10"
              placeholder="Your message"
              required
            ></textarea>
            <button type="submit" className="send-btn">
              SEND MESSAGE
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
